import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMyMonitoringAccountModel } from '@apps-common/types/portal/my-monitoring'

export const sendMyMonitoringAccountEmail = async (model: IMyMonitoringAccountModel): Promise<any> =>
  axios.post(`/MyMonitoringAccountManagement/SendAccountEmail`, model).then((res) => res?.data)

type Props = {
  model: IMyMonitoringAccountModel
}

export const useSendMyMonitoringAccountEmail = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['migrateMyMonitoringAccount'],
    mutationFn: ({ model }: Props) => sendMyMonitoringAccountEmail(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess(data?.msg || 'Email sent.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to send email.')
      }
    },
    throwOnError: false
  })
